import React from "react";
import AdminLayout from "./Common/AdminLayout";
import { useNavigate } from "react-router-dom";
import { 
  FaTools, 
  FaIndustry, 
  FaGraduationCap, 
  FaCertificate,
  FaBriefcase,
  FaImages,
  FaCreditCard,
  FaEnvelope,
  FaInfoCircle,
  FaShieldAlt
} from "react-icons/fa";
import "../../asset/new/css/admin-modern.css";

const MasterSettings = () => {
  const navigate = useNavigate();

  const settingsCards = [
    {
      title: "Skills",
      description: "Manage job skills and competencies",
      icon: <FaTools />,
      path: "/admin/skill",
      color: "primary",
      gradient: "linear-gradient(135deg, #4893B3 0%, #3a7a99 100%)"
    },
    {
      title: "Industries",
      description: "Manage industry categories",
      icon: <FaIndustry />,
      path: "/admin/industry",
      color: "success",
      gradient: "linear-gradient(135deg, #0E9F6E 0%, #057A55 100%)"
    },
    {
      title: "Degrees",
      description: "Manage educational degrees",
      icon: <FaGraduationCap />,
      path: "/admin/degrees",
      color: "info",
      gradient: "linear-gradient(135deg, #1C64F2 0%, #1A56DB 100%)"
    },
    {
      title: "Qualifications",
      description: "Manage qualification requirements",
      icon: <FaCertificate />,
      path: "/admin/qualification",
      color: "warning",
      gradient: "linear-gradient(135deg, #FF9500 0%, #FF8800 100%)"
    },
    {
      title: "Job Types",
      description: "Manage job type categories",
      icon: <FaBriefcase />,
      path: "/admin/jobtype",
      color: "purple",
      gradient: "linear-gradient(135deg, #9061F9 0%, #7E3AF2 100%)"
    },
    {
      title: "Sliders",
      description: "Manage homepage banner sliders",
      icon: <FaImages />,
      path: "/admin/sliders",
      color: "danger",
      gradient: "linear-gradient(135deg, #F05252 0%, #E02424 100%)"
    },
    {
      title: "Subscriptions",
      description: "Manage subscription packages",
      icon: <FaCreditCard />,
      path: "/admin/subscription",
      color: "primary",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
      title: "Contact Us",
      description: "Edit contact page content",
      icon: <FaEnvelope />,
      path: "/admin/contactus",
      color: "success",
      gradient: "linear-gradient(135deg, #0E9F6E 0%, #046C4E 100%)"
    },
    {
      title: "About Us",
      description: "Edit about page content",
      icon: <FaInfoCircle />,
      path: "/admin/aboutus",
      color: "info",
      gradient: "linear-gradient(135deg, #4893B3 0%, #3a7a99 100%)"
    },
    {
      title: "Privacy Policy",
      description: "Edit privacy policy content",
      icon: <FaShieldAlt />,
      path: "/admin/faq",
      color: "warning",
      gradient: "linear-gradient(135deg, #F59E0B 0%, #D97706 100%)"
    }
  ];

  const handleCardClick = (path) => {
    navigate(path);
  };

  return (
    <AdminLayout
      title="Master Settings"
      subtitle="Manage all system configurations and content"
      breadcrumbs={[
        { label: "Admin", active: false },
        { label: "Master Settings", active: true }
      ]}
    >
      <div className="admin-settings-grid">
        {settingsCards.map((card, index) => (
          <div
            key={index}
            className="admin-settings-card"
            onClick={() => handleCardClick(card.path)}
            style={{
              cursor: 'pointer',
              transition: 'all var(--transition-base)'
            }}
          >
            <div className="admin-settings-card-header">
              <div 
                className="admin-settings-card-icon"
                style={{ background: card.gradient }}
              >
                {card.icon}
              </div>
            </div>
            <div className="admin-settings-card-body">
              <h3 className="admin-settings-card-title">{card.title}</h3>
              <p className="admin-settings-card-description">{card.description}</p>
            </div>
            <div className="admin-settings-card-footer">
              <span className="admin-settings-card-link">
                Configure <i className="fas fa-arrow-right ms-2"></i>
              </span>
            </div>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
};

export default MasterSettings;
